@if (isPublicNavigationEnabled()) {
  <div class="header-logged-out">
    <ftr-logo [theme]="logoThemes.Themed" [static]="true" />
    <button ftrIconButton icon="HelpCircleLine" iconColor="Grey40" size="medium" (click)="openHelpAndSupport()">
      Help & Support
    </button>
  </div>
} @else {
  <div class="header-logged-out-legacy row align-items-center justify-content-center">
    <ftr-logo [theme]="logoThemes.Themed" [size]="logoSizes.Legacy" />
    <div class="help-button">
      <button
        class="elevio__help"
        ftrTooltip
        message="Help Center"
        [showDash]="false"
        alignment="center"
        position="left"
      >
        <ftr-icon-legacy icon="HelpCircleSolid" color="Primary" align="Top" size="ExtraLarge" />
      </button>
    </div>
  </div>
}
